module.exports = "../fonts/ProximaNova-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/ProximaNova-Regular.ttf
// module id = 585
// module chunks = 0